import { Box, Divider, List, Typography, useTheme } from "@mui/material";
import MobileHeader from "../../../../layout/OwnerLayout/Header";
import profileImage from "../../../../../media/images/profileImage.svg";
import { useAppSelector } from "../../../../../hooks/useRedux";
import CustomListItem from "./../ListItem";
import IdentityCardFillSVG from "../../../../../media/images/icons/identity-card";
import PhoneRingSVG from "../../../../../media/images/icons/phone-ring";
import LocationFill from "../../../../../media/images/icons/location-fill";
import { grey } from "@mui/material/colors";
import BuildingSingleFillSVG from "../../../../../media/images/icons/building-singlefill";
import NationalCardSVG from "../../../../../media/images/icons/national-card";
import AuthorizationOwnerLabel from "../../../../components/AuthorizationOwnerLabel";
import ShieldSecuritySVG from "../../../../../media/images/icons/shield-security";
import SmsTrackingIcon from "../../../../../media/images/icons/sms-tracking";
import UserSquerSVG from "../../../../../media/images/icons/squer-user";
import logoimage from "../../../../../media/images/logos/Logo-Karen.png";

export default function LegalEntityOwnerProfilePage() {
  const theme = useTheme();

  const { accomodationInfo, ownerInfo } = useAppSelector(
    (state) => state.owner
  );

  return (
    <>
      <MobileHeader
        title={
          <Typography
            sx={{
              fontWeight: 700,
              color: "secondary.main",
              fontSize: 16,
            }}
          >
            حساب کاربری من(حقوقی){" "}
          </Typography>
        }
      />
      <Box
        sx={{
          paddingX: "8px",
        }}
      >
        {/**section1 */}
        <Box
          sx={{
            position: "relative",
            marginTop: "32px",
            width: "100%",
            backgroundColor: "bgColor.white",
            padding: "16px",
            borderRadius: "16px",
          }}
        >
          <Box
            sx={{
              position: "absolute",
              top: -32,
              right: 32,
              // border: "1px solid gray",
              height: "64px",
              width: "64px",
            }}
          >
            <img
              style={{
                borderRadius: "50%",
              }}
              src={profileImage}
              alt=""
            />
          </Box>
          {/* <Box
            sx={{
              zIndex: 32,
              position: "absolute",
              right: 32,
              width: 28,
              height: 28,
              // border: "1px solid gray",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              borderRadius: "50%",
              backgroundColor: "bgColor.white",
            }}
          >
            <EditIcon size={20} color={theme.palette.primary.main} />
          </Box> */}
          {/* <Box sx={{ display: "flex", justifyContent: "end" }}>
            <CustomButton
              // loading={loading}
              // onClick={() => onOk()}
              flexDirection="row"
              title="حذف عکس پروفایل"
              justifyContent="center"
              bgColor="error.light"
              fSize="14px"
              textColor="error.main"
              fWeight="700"
              px="10px"
              py="10px"
              borderRadius="10px"
              icon1={<RubbishSVG color={theme.palette.error.main} size={22} />}
            />
          </Box> */}

          <Typography
            sx={{
              marginTop: "32px",
              color: theme.palette.secondary[600],
              fontWeight: "700",
              fontSize: "14px",
            }}
          >
            {ownerInfo?.surName || "--------"}
          </Typography>
          <AuthorizationOwnerLabel />

          <Box
            sx={{
              marginTop: "12px",
              padding: "8px 8px",
              borderRadius: "8px",
              backgroundColor: theme.palette.secondary[50],
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "4px",
              }}
            >
              <IdentityCardFillSVG color={grey[800]} />
              <Typography
                sx={{ fontWeight: "700", fontSize: "14px", color: grey[800] }}
              >
                کد ثبت:{" "}
              </Typography>
            </Box>
            <Typography
              sx={{
                fontWeight: "700",
                fontSize: "14px",
                color: theme.palette.secondary[600],
              }}
            >
              {ownerInfo?.regCode || "------"}
            </Typography>
          </Box>
          <Box
            sx={{
              marginTop: "8px",
              padding: "8px 8px",
              borderRadius: "8px",
              backgroundColor: theme.palette.secondary[50],
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "4px",
              }}
            >
              <IdentityCardFillSVG color={grey[800]} />
              <Typography
                sx={{ fontWeight: "700", fontSize: "14px", color: grey[800] }}
              >
                شناسه ملی:{" "}
              </Typography>
            </Box>
            <Typography
              sx={{
                fontWeight: "700",
                color: theme.palette.secondary[600],
                fontSize: "14px",
              }}
            >
              {ownerInfo?.companyNid || "-------"}
            </Typography>
          </Box>

          <Box
            sx={{
              marginTop: "8px",
              padding: "8px 8px",
              borderRadius: "8px",
              backgroundColor: theme.palette.secondary[50],
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "4px",
              }}
            >
              <LocationFill color={grey[800]} />

              <Typography
                sx={{ fontWeight: "700", fontSize: "14px", color: grey[800] }}
              >
                استان/شهر:{" "}
              </Typography>
            </Box>
            <Typography
              sx={{
                fontWeight: "700",
                color: theme.palette.secondary[600],
                fontSize: "14px",
              }}
            >
              {accomodationInfo?.cityInfo?.cityName || "-------"}
            </Typography>
          </Box>
          <Box
            sx={{
              marginTop: "8px",
              padding: "8px 8px",
              borderRadius: "8px",
              backgroundColor: theme.palette.secondary[50],
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "4px",
              }}
            >
              <BuildingSingleFillSVG size={22} color={grey[800]} />

              <Typography
                sx={{ fontWeight: "700", fontSize: "14px", color: grey[800] }}
              >
                کد پستی:{" "}
              </Typography>
            </Box>
            <Typography
              sx={{
                fontWeight: "700",
                color: theme.palette.secondary[600],
                fontSize: "14px",
              }}
            >
              {accomodationInfo?.postalCode || "-------"}
            </Typography>
          </Box>

          <Box
            sx={{
              gap: "8px",
              marginTop: "16px",
              display: "flex",
            }}
          >
            <Typography
              sx={{
                fontSize: "16px",
                fontWeight: "700",
              }}
            >
              آدرس:{" "}
            </Typography>
            <Typography
              sx={{
                fontSize: "14px",
                fontWeight: "600",
              }}
            >
              {accomodationInfo?.address || "--------"}
            </Typography>
          </Box>
        </Box>

        <Box
          sx={{
            marginTop: "16px",
            backgroundColor: "bgColor.white",
            borderRadius: "16px",
            padding: "16px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "4px",
            }}
          >
            <Typography
              sx={{
                color: "textColor.main",
                fontWeight: "700",
              }}
            >
              مدیرعامل:
            </Typography>
            <Typography
              sx={{
                fontWeight: "700",
                color: theme.palette.secondary[600],
              }}
            >
              {ownerInfo?.foreName || "-------"}
            </Typography>
          </Box>
          <Box
            sx={{
              marginTop: "8px",
              padding: "8px 8px",
              borderRadius: "8px",
              backgroundColor: theme.palette.secondary[50],
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "4px",
              }}
            >
              <NationalCardSVG color={grey[800]} />
              <Typography
                sx={{ fontWeight: "700", fontSize: "14px", color: grey[800] }}
              >
                کد ملی:{" "}
              </Typography>
            </Box>
            <Typography
              sx={{
                fontWeight: "700",
                color: theme.palette.secondary[600],
                fontSize: "14px",
              }}
            >
              {ownerInfo?.userName || "-------"}
            </Typography>
          </Box>
          <Box
            sx={{
              marginTop: "8px",
              padding: "8px 8px",
              borderRadius: "8px",
              backgroundColor: theme.palette.secondary[50],
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "4px",
              }}
            >
              <PhoneRingSVG color={grey[800]} />
              <Typography
                sx={{ fontWeight: "700", fontSize: "14px", color: grey[800] }}
              >
                شماره تلفن همراه:{" "}
              </Typography>
            </Box>
            <Typography
              sx={{
                fontWeight: "700",
                color: theme.palette.secondary[600],
                fontSize: "14px",
              }}
            >
              {ownerInfo?.phoneNumber || "-------"}
            </Typography>
          </Box>
        </Box>

        {/**section2 */}

        <Box
          sx={{
            marginTop: "16px",
            width: "100%",
            backgroundColor: "bgColor.white",
            borderRadius: "16px",
          }}
        >
          <nav
            style={{
              padding: "0px 8px",
            }}
            aria-label="main mailbox folders"
          >
            <List
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: "4px",
              }}
            >
              <CustomListItem
                path="../edit-profile"
                title="ویرایش اطلاعات و ارسال مدارک"
                icon={<UserSquerSVG color={theme.palette.textColor.main} />}
              />
              <Divider variant="middle" />
              <CustomListItem
                path="../change-password"
                title="تغییر رمز عبور"
                icon={
                  <ShieldSecuritySVG color={theme.palette.textColor.main} />
                }
              />
              <Divider variant="middle" />
              <CustomListItem
                path="../change-mobile"
                title="تغییر شماره همراه"
                icon={
                  <SmsTrackingIcon
                    color={theme.palette.textColor.main}
                    size={28}
                  />
                }
              />
              <Divider variant="middle" />
              {/* <CustomListItem
                path="#"
                title="تنظیمات اطلاع‌رسانی و دسترسی‌ها"
                icon={settingsIcon}
              /> */}
              {/* <Divider variant="middle" /> */}
              <CustomListItem
                path="/aboutus"
                title="درباره کارن ترابر نت"
                icon={<img width={28} src={logoimage} alt="" />}
                // icon={<LogoKarenSVG color={theme.palette.textColor.main} />}
              />
            </List>
          </nav>
        </Box>
      </Box>
    </>
  );
}
